<div class="row contributorsList">
    <div class="contributor" *ngFor="let contributor of contributorList">
        <div class="contributor-padding">
            <div class="profile"> 
                <img src="{{path}}{{contributor.Image}}" class="rounded-circle" width="80">
            </div>
            <div class="contributor-name" (click)="navigateToPeoplePage(contributor.Enterprise_Id)">
                {{contributor.Name}}
            </div>
        </div>
    </div>
</div>

